import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { QuestionnaireOrSelectNumberModalStore } from 'entities/Phone/ui/QuestionnaireOrSelectNumberModal'
import { type BillingPlan } from 'entities/Billing/model/BillingPlan'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class UpgradePlanModalFinishStore {
  private _idFinishModal = 'upgradePlanFinishModal'
  private _plan: BillingPlan | null = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get plan() {
    if (!this._plan) return ''

    return this._plan.label
  }

  get title() {
    return (
      <>
        Congrats! <br /> You have just upgraded to {this.plan} plan
      </>
    )
  }

  get description() {
    if (this.isShowQuestionnaireOrSelectNumberModal) {
      return "We'll ask a few quick questions to tailor your experience"
    }

    return ''
  }

  get textButton() {
    if (this.isShowQuestionnaireOrSelectNumberModal) {
      return 'Get started'
    }

    return 'Done'
  }

  get trialSubscriptionStore() {
    return this._entities.subscriptionStore.trialSubscriptionStore
  }

  get isShowQuestionnaireOrSelectNumberModal() {
    return (
      !this.trialSubscriptionStore.isQuestionnaire || !this.trialSubscriptionStore.isNumberSelected
    )
  }

  setPlan = (value: string) => {
    const plan = this._entities.billingStore.billingPlansStore.getItem(value)

    if (plan) {
      this._plan = plan
    }
  }

  openFinishModal = async (planId: string) => {
    await Promise.all([
      this._entities.usersStore.initPromise,
      this._entities.complianceStore.fetchSummary(),
      this._entities.billingStore.fetchPlans(),
    ])

    this.setPlan(planId)

    modalStore.addModal({
      id: this._idFinishModal,
      type: ModalTypeList.SUCCESS,
      title: this.title,
      desc: this.description,
      disabledOnAllClose: true,
      disabledOnEscClose: true,
      disabledOverlayClose: true,
      showCloseButton: false,
      primaryAction: {
        text: this.textButton,
        onAction: () => {
          this.onAction()
        },
      },
    })
  }

  onAction = () => {
    if (this.isShowQuestionnaireOrSelectNumberModal) {
      new QuestionnaireOrSelectNumberModalStore(this._entities).init()
    }

    modalStore.removeModal(this._idFinishModal)
  }
}
